export default __webpack_public_path__ + "static/media/yellow_swirl.7fa00bdf.png";